/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./consumerDetails.vue?vue&type=template&id=270fca81"
import script from "./consumerDetails.vue?vue&type=script&lang=js"
export * from "./consumerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports